import { Component, Output, EventEmitter, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-edit-azienda',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './edit-azienda.component.html',
  styleUrls: ['./edit-azienda.component.css']
})
export class EditAziendaComponent {
  @Output() aziendaModalOpen = new EventEmitter<boolean>();
  @Input() medicineData: any;
  @Output() saveChanges = new EventEmitter<void>();

  editedMedicineData: any;

  private readonly DEFAULT_COLORS = {
    title: '#000000',
    text: '#969696',
    bg: '#FFFFFF'
  };

  titleColor: string = this.DEFAULT_COLORS.title;
  titleHex: string = this.formatHex(this.titleColor);

  textColor: string = this.DEFAULT_COLORS.text;
  textHex: string = this.formatHex(this.textColor);

  bgColor: string = this.DEFAULT_COLORS.bg;
  bgHex: string = this.formatHex(this.bgColor);

  imagePreview: string | null = null;

  fontTitoliName: string = '';
  fontTestiName: string = '';
  fontTitoliError: string = '';
  fontTestiError: string = '';

  canUserSave: boolean = true;

  ngOnInit (): void {
    console.log("original from", this.medicineData);
    this.editedMedicineData = { ...this.medicineData };
    this.imagePreview = this.editedMedicineData.medicineBrandInfo.logo.url || null;
  }

  // COLORS LOGIC
  private formatHex (value: string): string {
    if (!value) return '';
    return value.startsWith('#')
      ? value.toUpperCase()
      : `#${value.toUpperCase()}`;
  }

  updateHex (
    colorVar: 'titleColor' | 'textColor' | 'bgColor',
    hexVar: 'titleHex' | 'textHex' | 'bgHex'
  ) {
    this[hexVar] = this.formatHex(this[colorVar]);
  }

  updateColor (
    hexVar: 'titleHex' | 'textHex' | 'bgHex',
    colorVar: 'titleColor' | 'textColor' | 'bgColor'
  ) {
    const value = this[hexVar];

    if (!value || value.trim() === '') {
      const defaultKey = colorVar.replace('Color', '') as keyof typeof this.DEFAULT_COLORS;
      const defaultValue = this.DEFAULT_COLORS[defaultKey];

      this[hexVar] = this.formatHex(defaultValue);
      this[colorVar] = defaultValue;
      return;
    }

    const hexRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/i;

    if (hexRegex.test(value)) {
      const formattedValue = this.formatHex(value);
      this[hexVar] = formattedValue;
      this[colorVar] = formattedValue;
    } else {
      this[hexVar] = this.formatHex(this[colorVar]);
    }
  }

  // LOGO 
  onFileSelected (event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        this.imagePreview = reader.result as string;
      };
      reader.readAsDataURL(file);
    }
  }

  removeImage (fileInput: HTMLInputElement): void {
    this.imagePreview = null;
    fileInput.value = '';
  }



  // FONTS
  onFontTitoliSelected (event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fontTitoliName = input.files[0].name;
      const extension = this.fontTitoliName.split('.').pop()?.toLowerCase();
      if (extension === 'ttf' || extension === 'otf') {
        this.fontTitoliError = ""; // Nessun errore
      } else {
        this.fontTitoliError = 'Formato non valido. Sono ammessi solo file .ttf o .otf';
      }
    }
  }

  onFontTestiSelected (event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.fontTestiName = input.files[0].name;
      const extension = this.fontTestiName.split('.').pop()?.toLowerCase();
      if (extension === 'ttf' || extension === 'otf') {
        this.fontTestiError = ""; // Nessun errore
      } else {
        this.fontTestiError = 'Formato non valido. Sono ammessi solo file .ttf o .otf';
      }
    }
  }

  cancelFont (value: string) {
    if (value == "titoli") {
      this.fontTitoliName = "";
      this.fontTitoliError = "";
    } else if (value == "testi") {
      this.fontTestiName = "";
      this.fontTestiError = "";
    }

  }

  onSaveChanges () {
    console.log("edited", this.editedMedicineData);
    this.saveChanges.emit(this.editedMedicineData);
    this.closeModal();
  }


  // CLOSE IT
  closeModal () {
    this.aziendaModalOpen.emit(false);
  }
}
